export default "__VITE_ASSET__CHUWd$$9__"